export const CART_CONSTRAINTS = {
  SET_CART_ITEMS_LIST: "SET_CART_ITEMS_LIST",
  SET_REPEATER_REQUEST_TYPES: "SET_REPEATER_REQUEST_TYPES",
  SET_AVAILABLE_SLOTS: "SET_AVAILABLE_SLOTS",
  SET_FIRST_AVAILABLE_DATE: "SET_FIRST_AVAILABLE_DATE",
  SET_UNAVAILABLE_DAYS: "SET_UNAVAILABLE_DAYS",
  SET_CART_DETAILS: "SET_CART_DETAILS",
};
